module.exports = __webpack_public_path__ + "img/sf-logo.b1e80f1b.png";